import React from 'react';
import {
  Card, Typography, Box, CardContent, Grid, Divider,
} from '@material-ui/core';
import type { IRepairJob } from '../marking/MarkingInterfaces';
import RepairProperty from '../metalCollection/RepairProperty';

const RepairJobContainer: React.FC<{
  repairJobs:IRepairJob[],
  title: string,
}> = ({ repairJobs, title }) => {
  const JobMap = (
    repairJobs?.map((job) => (
      <Grid container>
        <Grid item lg={4} md={6} xs={12}>
          <RepairProperty
            title={job.selectedOption}
            subtitle={job.repairItemLabels?.[0] ? `Resize ${job.repairItemLabels.join(', ')}` : 'Resize Ring'}
            isRejected={job.rejected}
          />
        </Grid>
      </Grid>
    ))
  );

  return (
    <Card>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Box ml={2} my={2}>
            <Typography variant="h5" style={{ fontSize: '1.125rem' }}>{title}</Typography>
          </Box>
        </Grid>
        <Grid item>
          <Box mr={2} mt={2.5}>
            <Typography variant="h5" style={{ fontSize: '.875rem', color: '#A5A5A5', textTransform: 'uppercase' }}>
              {`${repairJobs && repairJobs.length > 1
                ? `${repairJobs.length} Jobs`
                : '1 Job'}`}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={2}
        >
          {JobMap}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RepairJobContainer;
